import React from "react";
import { Link } from "react-router-dom";

const ArrowIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CheckIcon = () => (
  <svg className="w-4 h-4 text-fut-primary shrink-0 mt-1" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CreditRepairLanding = ({ translations = {} }) => {
  const isSpanish = translations?.header?.home === "Inicio";

  const t = isSpanish
    ? {
        programTitle: "Programa Restauración Crediticia 360",
        programText:
          "Una ruta para personas rechazadas por bancos, concesionarios, tarjetas, vivienda o financiamiento que necesitan entender, disputar, ordenar y reconstruir su perfil con seguimiento.",
        offerItems: [
          "Diagnóstico de 5 Pilares Crediticios",
          "Auditoría de derogatorias y colecciones",
          "Disputas estratégicas",
          "Guía de validación de deuda",
          "Reporte mensual de avance",
          "Dieta de crédito y educación financiera",
          "Portal / bóveda de seguimiento",
          "Plan de reconstrucción crediticia",
          "Ruta futura hacia financiamiento",
        ],

        eyebrow: "Diagnóstico de 5 Pilares Crediticios",
        title: "¿Te negaron crédito, auto, casa o financiamiento?",
        subtitle:
          "Antes de pagar una colección, disputar cuentas o contratar a alguien, necesitas saber qué está dañando realmente tu reporte.",
        intro:
          "En San Jose Obrero LLC revisamos tu perfil con un Diagnóstico de 5 Pilares Crediticios para identificar factores negativos, errores posibles, utilización alta, colecciones y oportunidades reales de reconstrucción.",
        primaryCta: "Solicitar diagnóstico por teléfono",

        formTitle: "Solicita tu llamada de diagnóstico",
        formText:
          "Completa tus datos. La llamada es para entender tu situación, tus metas y si tu caso tiene una ruta razonable de trabajo.",
        fields: {
          name: "Nombre completo",
          phone: "Teléfono",
          email: "Correo electrónico",
          goal: "¿Cuál es tu meta principal?",
          situation: "Describe brevemente qué pasó o qué necesitas lograr",
        },
        goals: [
          "Me negaron crédito",
          "Quiero comprar auto",
          "Quiero comprar casa",
          "Tengo colecciones",
          "Tengo cuentas negativas",
          "Quiero prepararme para financiamiento",
        ],
        submit: "Solicitar llamada",

        problemTitle: "El error común es actuar sin diagnóstico",
        problemHeading: "Primero se entiende el daño. Después se decide la estrategia.",
        problemText:
          "Muchas personas pagan cuentas, envían disputas o aceptan acuerdos sin saber si eso realmente les ayuda. Primero hay que revisar el reporte, entender qué lo está afectando y decidir qué acción tiene sentido.",
        callObjectiveTitle: "Objetivo de la llamada",
        callObjectiveText:
          "Saber si tu caso tiene una ruta razonable antes de gastar más dinero o tomar decisiones que puedan empeorar tu reporte.",

        pillarsTitle: "Los 5 pilares que revisamos",
        pillars: [
          ["Historial de pagos", "Pagos atrasados, patrones negativos y cuentas que afectan la confianza del perfil."],
          ["Utilización de crédito", "Saldos altos, límites disponibles y presión que puede estar afectando tu perfil."],
          ["Antigüedad del historial", "Edad de las cuentas, cierres recientes y estabilidad del historial."],
          ["Mezcla de cuentas", "Tipo de cuentas abiertas, variedad del perfil y estructura general."],
          ["Derogatorias y consultas", "Colecciones, charge-offs, late payments, inquiries y cuentas sospechosas."],
        ],

        processTitle: "Cómo te guiamos desde la primera llamada",
        processHeading: "Una ruta clara para decidir si avanzar.",
        process: [
          ["1. Agenda tu llamada", "Nos explicas qué te negaron, qué meta tienes y qué problema ves en tu reporte."],
          ["2. Revisamos tu situación general", "Identificamos si el problema viene de utilización, pagos atrasados, colecciones, cuentas negativas o consultas."],
          ["3. Te decimos si existe una ruta razonable", "Si tu caso no tiene oportunidad clara, te lo decimos. Si la tiene, te explicamos por dónde empezar."],
          ["4. Iniciamos proceso documentado", "Se preparan disputas estratégicas para información potencialmente inexacta, incompleta o no verificable."],
          ["5. Recibes seguimiento", "Te mostramos avances, respuestas, fechas, burós contactados y próximos pasos."],
        ],

        debtTitle: "Si tienes colecciones, no pagues a ciegas",
        debtHeading: "Las colecciones se manejan con documentos, no con impulso.",
        debtIntro:
          "Cuando hay deudas o cuentas en colección, el objetivo no es correr a pagar. Primero revisamos si existe documentación, cómo aparece la cuenta y qué opción puede proteger mejor tu posición.",
        debtSteps: [
          ["1. Exigir validación", "Antes de pagar, se revisa si conviene pedir prueba de la deuda y documentación de respaldo."],
          ["2. Evaluar la respuesta", "Analizamos si la agencia presenta contrato, acreedor original, estado final y documentación suficiente."],
          ["3. Revisar el reporte", "Comparamos la información reportada con la documentación y buscamos inconsistencias."],
          ["4. Negociar por escrito", "Si la deuda es válida y conviene negociar, todo debe quedar por escrito antes de pagar."],
          ["5. Pago seguro si aplica", "Si se paga, debe hacerse de forma segura y conservando evidencia del acuerdo y del pago."],
        ],

        noticeTitle: "Aviso importante",
        notice:
          "San José Obrero LLC no garantiza aprobación de crédito, aumento específico de puntaje ni eliminación de información negativa exacta, actual y verificable. El servicio consiste en análisis, educación, preparación documental, disputas de información potencialmente inexacta, incompleta o no verificable, seguimiento del proceso y orientación estratégica. Los resultados dependen de la información contenida en el reporte, la respuesta de burós, acreedores, cobradores y la conducta financiera del cliente durante el proceso.",

        finalTitle: "Agenda tu Diagnóstico de 5 Pilares",
        finalText:
          "Una llamada seria para saber dónde estás parado y qué ruta puede tener sentido para tu caso.",
        callLabel: "Llamar",
        whatsappLabel: "WhatsApp",
      }
    : {
        programTitle: "Credit Restoration 360 Program",
        programText:
          "A route for people rejected by banks, dealerships, cards, housing, or financing who need to understand, dispute, organize, and rebuild their profile with follow-up.",
        offerItems: [
          "5-Pillar Credit Diagnosis",
          "Derogatory and collection audit",
          "Strategic disputes",
          "Debt validation guidance",
          "Monthly progress report",
          "Credit diet and financial education",
          "Tracking portal / vault",
          "Credit reconstruction plan",
          "Future route toward financing",
        ],

        eyebrow: "5-Pillar Credit Diagnosis",
        title: "Were you denied credit, auto, housing, or financing?",
        subtitle:
          "Before paying a collection, disputing accounts, or hiring someone, you need to understand what is actually damaging your report.",
        intro:
          "At San Jose Obrero LLC, we review your profile through a 5-Pillar Credit Diagnosis to identify negative factors, possible errors, high utilization, collections, and real reconstruction opportunities.",
        primaryCta: "Request phone diagnosis",

        formTitle: "Request your diagnosis call",
        formText:
          "Complete your information. The call is meant to understand your situation, your goals, and whether your case has a reasonable path forward.",
        fields: {
          name: "Full name",
          phone: "Phone",
          email: "Email",
          goal: "What is your main goal?",
          situation: "Briefly describe what happened or what you need to achieve",
        },
        goals: [
          "I was denied credit",
          "I want to buy a car",
          "I want to buy a home",
          "I have collections",
          "I have negative accounts",
          "I want to prepare for financing",
        ],
        submit: "Request call",

        problemTitle: "The common mistake is acting without diagnosis",
        problemHeading: "First, the damage is understood. Then the strategy is decided.",
        problemText:
          "Many people pay accounts, send disputes, or accept agreements without knowing whether that actually helps them. First, the report must be reviewed, the damage must be understood, and the right action must be chosen.",
        callObjectiveTitle: "Purpose of the call",
        callObjectiveText:
          "To know whether your case has a reasonable route before spending more money or making decisions that may worsen your report.",

        pillarsTitle: "The 5 pillars we review",
        pillars: [
          ["Payment history", "Late payments, negative patterns, and accounts that affect profile trust."],
          ["Credit utilization", "High balances, available limits, and pressure that may affect your profile."],
          ["Age of history", "Age of accounts, recent closures, and stability of the history."],
          ["Credit mix", "Types of open accounts, profile variety, and overall structure."],
          ["Derogatories and inquiries", "Collections, charge-offs, late payments, inquiries, and suspicious accounts."],
        ],

        processTitle: "How we guide you from the first call",
        processHeading: "A clear route to decide whether to move forward.",
        process: [
          ["1. Schedule your call", "You explain what you were denied, what goal you have, and what problem you see in your report."],
          ["2. We review your general situation", "We identify whether the problem comes from utilization, late payments, collections, negative accounts, or inquiries."],
          ["3. We explain if there is a reasonable route", "If your case does not have a clear opportunity, we tell you. If it does, we explain where to start."],
          ["4. We start a documented process", "Strategic disputes are prepared for information that may be inaccurate, incomplete, or unverifiable."],
          ["5. You receive follow-up", "We show progress, responses, dates, bureaus contacted, and next steps."],
        ],

        debtTitle: "If you have collections, do not pay blindly",
        debtHeading: "Collections are handled with documents, not impulse.",
        debtIntro:
          "When there are debts or collection accounts, the goal is not to rush into payment. First, we review whether documentation exists, how the account appears, and what option may better protect your position.",
        debtSteps: [
          ["1. Request validation", "Before paying, we review whether it makes sense to request proof of the debt and supporting documentation."],
          ["2. Evaluate the response", "We analyze whether the agency provides the contract, original creditor, final statement, and sufficient documentation."],
          ["3. Review the report", "We compare the reported information against the documentation and look for inconsistencies."],
          ["4. Negotiate in writing", "If the debt is valid and negotiation makes sense, everything should be in writing before payment."],
          ["5. Safe payment if applicable", "If payment is made, it should be done safely while keeping evidence of the agreement and payment."],
        ],

        noticeTitle: "Important notice",
        notice:
          "San Jose Obrero LLC does not guarantee credit approval, any specific score increase, or removal of accurate, current, and verifiable negative information. The service consists of analysis, education, document preparation, disputes of information that may be inaccurate, incomplete, or unverifiable, process follow-up, and strategic guidance. Results depend on the information contained in the report, the response of credit bureaus, creditors, collectors, and the client’s financial conduct during the process.",

        finalTitle: "Schedule your 5-Pillar Diagnosis",
        finalText:
          "A serious call to understand where you stand and which route may make sense for your case.",
        callLabel: "Call",
        whatsappLabel: "WhatsApp",
      };

  return (
    <main className="min-h-screen bg-[#050B14] text-fut-text-light font-sans pb-20 md:pb-0 overflow-hidden">
      <section className="relative px-6 pt-32 md:pt-40 pb-16 md:pb-24">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_16%_14%,rgba(0,212,255,.22),transparent_26%),radial-gradient(circle_at_88%_24%,rgba(59,130,246,.16),transparent_28%),linear-gradient(135deg,#001A33_0%,#06111f_45%,#020617_100%)]" />

        <div className="relative container mx-auto max-w-screen-xl">
          {/* PRIMERA PARTE */}
          <section className="mb-20 grid lg:grid-cols-[.9fr_1.1fr] gap-8 items-center">
            <div>
              <p className="text-fut-primary font-bold uppercase tracking-[.22em] mb-5">
                San Jose Obrero LLC
              </p>
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-black leading-[1.02] mb-6 text-white">
                {t.programTitle}
              </h1>
              <p className="text-xl md:text-2xl text-fut-text-light/85 leading-relaxed mb-8">
                {t.programText}
              </p>
              <a
                href="#diagnosis-form"
                className="inline-flex items-center justify-center gap-2 bg-fut-primary text-fut-bg-dark px-7 py-4 rounded-2xl font-black shadow-xl shadow-fut-primary/15"
              >
                {t.primaryCta}
                <ArrowIcon />
              </a>
            </div>

            <div className="rounded-[3rem] bg-white/[.045] p-6 md:p-8 shadow-2xl shadow-fut-primary/10">
              <div className="grid sm:grid-cols-2 gap-3">
                {t.offerItems.map((item) => (
                  <div key={item} className="flex gap-3 rounded-[2rem] bg-black/18 p-4">
                    <CheckIcon />
                    <p className="text-fut-text-light/85 text-sm leading-relaxed">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* SEGUNDA PARTE */}
          <section className="mb-20 grid lg:grid-cols-[1fr_.8fr] gap-10 items-start">
            <div>
              <p className="text-fut-primary font-bold uppercase tracking-[.22em] mb-5">
                {t.eyebrow}
              </p>

              <h2 className="text-4xl md:text-6xl font-display font-black leading-tight mb-6 text-white">
                {t.title}
              </h2>

              <p className="text-xl md:text-2xl text-fut-text-light/90 leading-relaxed mb-5">
                {t.subtitle}
              </p>

              <p className="text-lg text-fut-text-light/75 leading-relaxed max-w-3xl mb-8">
                {t.intro}
              </p>

              <a
                href="#diagnosis-form"
                className="inline-flex items-center justify-center gap-2 bg-fut-primary text-fut-bg-dark px-7 py-4 rounded-2xl font-black shadow-xl shadow-fut-primary/15"
              >
                {t.primaryCta}
                <ArrowIcon />
              </a>

              <div className="mt-12 grid lg:grid-cols-[.9fr_1.1fr] gap-6 items-start">
                <div>
                  <p className="text-fut-primary font-black uppercase tracking-[.18em] text-sm mb-4">
                    {t.problemTitle}
                  </p>
                  <h3 className="text-3xl md:text-4xl font-display font-black text-white leading-tight mb-4">
                    {t.problemHeading}
                  </h3>
                  <p className="text-fut-text-light/78 text-lg leading-relaxed">
                    {t.problemText}
                  </p>
                </div>

                <div className="rounded-[3rem] bg-gradient-to-br from-fut-primary/14 via-white/[.045] to-white/[.025] p-6 md:p-8 shadow-2xl shadow-fut-primary/10">
                  <p className="text-fut-primary font-black uppercase tracking-[.18em] text-sm mb-4">
                    {t.callObjectiveTitle}
                  </p>
                  <p className="text-white text-2xl font-display font-black leading-tight">
                    {t.callObjectiveText}
                  </p>
                </div>
              </div>
            </div>

            <div
              id="diagnosis-form"
              className="rounded-[3rem] border border-fut-primary/25 bg-white/[.06] backdrop-blur-xl p-5 md:p-7 shadow-2xl shadow-fut-primary/12"
            >
              <h2 className="text-2xl md:text-3xl font-display font-black text-fut-primary mb-2">
                {t.formTitle}
              </h2>
              <p className="text-fut-text-light/75 mb-5">{t.formText}</p>

              <form
                name="credit-diagnosis"
                method="POST"
                data-netlify="true"
                netlify-honeypot="bot-field"
                action="/services/credit-repair"
                className="space-y-3"
              >
                <input type="hidden" name="form-name" value="credit-diagnosis" />
                <p className="hidden">
                  <label>Don’t fill this out: <input name="bot-field" /></label>
                </p>

                <input name="name" required placeholder={t.fields.name} className="w-full rounded-2xl bg-white text-slate-900 px-4 py-3" />
                <input name="phone" required placeholder={t.fields.phone} className="w-full rounded-2xl bg-white text-slate-900 px-4 py-3" />
                <input name="email" type="email" placeholder={t.fields.email} className="w-full rounded-2xl bg-white text-slate-900 px-4 py-3" />

                <select name="goal" required className="w-full rounded-2xl bg-white text-slate-900 px-4 py-3">
                  <option value="">{t.fields.goal}</option>
                  {t.goals.map((goal) => (
                    <option key={goal} value={goal}>{goal}</option>
                  ))}
                </select>

                <textarea name="situation" placeholder={t.fields.situation} className="w-full rounded-2xl bg-white text-slate-900 px-4 py-3 min-h-[110px]" />

                <label className="flex items-start gap-3 rounded-2xl border border-fut-primary/25 bg-white/[.06] p-4 text-sm text-fut-text-light/85">
                  <input type="checkbox" name="policy_acceptance" value="accepted" required className="mt-1 h-4 w-4 shrink-0 accent-fut-primary" />
                  <span>
                    {isSpanish ? (
                      <>
                        Acepto la{" "}
                        <Link to="/policies" className="text-fut-primary font-bold underline">
                          Política de Privacidad y los Términos / Políticas Operativas
                        </Link>{" "}
                        de San Jose Obrero LLC.
                      </>
                    ) : (
                      <>
                        I accept the{" "}
                        <Link to="/policies" className="text-fut-primary font-bold underline">
                          Privacy Policy and Terms / Operating Policies
                        </Link>{" "}
                        of San Jose Obrero LLC.
                      </>
                    )}
                  </span>
                </label>

                <button type="submit" className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-fut-primary text-fut-bg-dark px-6 py-4 font-black text-lg hover:bg-fut-secondary transition-all duration-300">
                  {t.submit}
                  <ArrowIcon />
                </button>
              </form>
            </div>
          </section>

          <section className="mb-20">
            <h2 className="text-3xl md:text-5xl font-display font-black text-white leading-tight mb-8">
              {t.pillarsTitle}
            </h2>
            <div className="grid md:grid-cols-5 gap-4">
              {t.pillars.map(([title, text]) => (
                <article key={title} className="rounded-[2.5rem] bg-white/[.045] p-5 shadow-2xl shadow-fut-primary/8">
                  <CheckIcon />
                  <h3 className="text-white font-black text-lg mt-4 mb-2">{title}</h3>
                  <p className="text-fut-text-light/75 text-sm leading-relaxed">{text}</p>
                </article>
              ))}
            </div>
          </section>

          {/* TERCERA PARTE */}
          <section className="mb-20 grid lg:grid-cols-[.85fr_1.15fr] gap-8 items-start">
            <div>
              <p className="text-fut-primary font-black uppercase tracking-[.18em] text-sm mb-4">
                {t.processTitle}
              </p>
              <h2 className="text-3xl md:text-5xl font-display font-black text-white leading-tight">
                {t.processHeading}
              </h2>
            </div>

            <div className="space-y-4">
              {t.process.map(([title, text]) => (
                <article key={title} className="rounded-[2.5rem] bg-white/[.045] p-5 shadow-xl shadow-fut-primary/8">
                  <h3 className="text-white font-black text-xl mb-1">{title}</h3>
                  <p className="text-fut-text-light/75 leading-relaxed">{text}</p>
                </article>
              ))}
            </div>
          </section>

          {/* CUARTA PARTE */}
          <section className="mb-20 grid lg:grid-cols-[.75fr_1.25fr] gap-8 items-start">
            <div>
              <p className="text-fut-primary font-black uppercase tracking-[.18em] text-sm mb-4">
                {t.debtTitle}
              </p>
              <h2 className="text-3xl md:text-5xl font-display font-black text-white leading-tight mb-5">
                {t.debtHeading}
              </h2>
              <p className="text-fut-text-light/78 text-lg leading-relaxed">
                {t.debtIntro}
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {t.debtSteps.map(([title, text]) => (
                <article key={title} className="rounded-[2.5rem] bg-white/[.045] p-5 shadow-xl shadow-fut-primary/8">
                  <h3 className="text-fut-primary font-black text-xl mb-2">{title}</h3>
                  <p className="text-fut-text-light/75 leading-relaxed">{text}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="mb-20 rounded-[2.5rem] bg-fut-primary/12 p-6 md:p-8">
            <p className="text-fut-primary font-black uppercase tracking-[.18em] text-sm mb-3">
              {t.noticeTitle}
            </p>
            <p className="text-fut-text-light/85 leading-relaxed">
              {t.notice}
            </p>
          </section>

          <section className="relative rounded-[3rem] overflow-hidden bg-fut-primary text-fut-bg-dark p-8 md:p-12">
            <div className="absolute -right-20 -top-20 w-80 h-80 rounded-full bg-white/20 blur-3xl" />
            <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
              <div>
                <h2 className="text-3xl md:text-5xl font-display font-black leading-tight mb-3">
                  {t.finalTitle}
                </h2>
                <p className="font-semibold opacity-90 max-w-3xl">
                  {t.finalText}
                </p>
              </div>

              <a href="#diagnosis-form" className="inline-flex items-center justify-center gap-2 rounded-2xl bg-fut-bg-dark text-white px-7 py-4 font-black shrink-0">
                {t.primaryCta}
                <ArrowIcon />
              </a>
            </div>
          </section>
        </div>
      </section>

      <div className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 md:hidden border-t border-fut-primary/30">
        <a href="tel:+18884536026" className="bg-white text-fut-bg-dark py-4 text-center font-black">
          {t.callLabel}
        </a>
        <a href="https://wa.me/19495687938" className="bg-fut-primary text-fut-bg-dark py-4 text-center font-black">
          {t.whatsappLabel}
        </a>
      </div>
    </main>
  );
};

export default CreditRepairLanding;
